import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const AboutUsItem = (props) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        bgcolor: "white",
        borderRadius: 2,
        border: "1px solid rgba(6, 57, 112, 0.1)",
        boxShadow: "0 16px 44px rgba(6, 57, 112, 0.1)",
        p: { xs: 2.25, md: 3 },
        height: "100%",
        width: "100%",
      }}
    >
      <Typography
        variant="h4"
        component="h2"
        color={theme.palette.primary.main}
        sx={{
          fontFamily: "Georgia, 'Times New Roman', serif",
          fontStyle: "italic",
          fontWeight: 500,
          mb: 1.5,
        }}
      >
        {props.name}
      </Typography>
      {props.content}
    </Box>
  );
};

export default AboutUsItem;
